import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { CreatePageDialogComponent } from './createpagedialogcomponent/createpagedialogcomponent.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-activitiespageview',
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatDatepickerModule,
    MatInputModule,
    TranslateDirective
  ],
  templateUrl: './activitiespageview.component.html',
  styleUrls: ['./activitiespageview.component.scss'],
})
export class ActivitiesPageViewComponent implements OnInit {
  @Input() apiEndPoint!: string;
  @Input() websiteId!: string;
  @Input() pageId!: string;
  displayedColumns: string[] = ['id', 'page_name', 'createdAt', 'actions'];
  activitiesData: any = [];
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private apiServices: ApiservicesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.websiteId = this.route.snapshot?.queryParams['websiteId'];
    this.pageId = this.route.snapshot?.queryParams['pageId'];
    this.apiEndPoint = this.route.snapshot?.queryParams['endpoint'];
    this.getActivitiesData();
  }

  openCreatePageDialog(): void {
    const dialogRef = this.dialog.open(CreatePageDialogComponent, {
      width: '400px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const newActivity = {
          id: this.activitiesData.length + 1,
          sub_menu: result,
          status: 'active',
          image_url: '',
          data_json: [],
        };
        this.activitiesData;
      }
      this.getActivitiesData();
    });
  }

  editItem(element: any): void {
    const dialogConfig = this.dialog.open(CreatePageDialogComponent, {
      minHeight: '65vh',
      maxHeight: '65vh',
      maxWidth: '70vw',
      minWidth: '70vw',
      data: {
        activityData: element, // Selected activity data
        isEditMode: true,
      },
    });

    dialogConfig.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getActivitiesData(); // Refresh the data
      }
    });
  }

  onDelete(itemId: number): void {
    if (confirm('Are you sure you want to delete this item?')) {
      this.apiServices.deleteActivitiesPage(itemId).subscribe({
        next: (response) => {
          this.getActivitiesData();
        },
        error: (err) => {
          console.error('Error deleting item:', err);
        },
      });
    }
  }

  navigateToActivityPage(id: number, data: any): void {
    this.router.navigate([`/activities/${id}`], {
      state: { activityData: data },
    });
  }

  getActivitiesData() {
    this.apiServices
      .getActivitiesPagelist(this.websiteId, this.pageId, this.apiEndPoint)
      .subscribe(
        (data: any) => {
          this.activitiesData = Array.isArray(data?.rows) ? data.rows : [];
        },
        (error) => {
          console.error('Error fetching activities data:', error);
          alert('Failed to load activities. Please try again later.');
        }
      );
  }
}
